import React__default from 'react';

const defaultContextValue = {
    variant: "text",
    inverse: false,
    onValueChange: undefined,
    showIcon: false,
};
// Create context with default values
const TabsContext = React__default.createContext(defaultContextValue);
// Hook to use the Tabs context
const useTabsContext = () => React__default.useContext(TabsContext);

export { TabsContext, useTabsContext };
